<template>
  <div>
    <!--  奖金转电子币 新增-->
    <app-breadcrumb />
    <div class="page-container">
      <el-form ref="addRef" :rules="rules" :model="listQuery" label-width="160px" size="mini">
        <!-- 奖金账户 -->
        <el-form-item :label="$t('fi.lable.award.account')+ ':'">
          <span style="color: #ff0021; font-size: large">{{ balance }}</span>
        </el-form-item>
        <!-- 付款金额 -->
        <el-form-item :label="$t('fi.pay.money')+ ':'" prop="money">
          <el-input v-model.number="listQuery.money" readonly onfocus="this.removeAttribute('readonly')" clearable style="width: 20%" />
        </el-form-item>
        <!-- 请输入您的支付密码 -->
        <el-form-item :label="$t('please.input.your.pay.password')+ ':'" prop="payPassword">
          <el-input show-password v-model.trim="listQuery.payPassword" readonly onfocus="this.removeAttribute('readonly')" clearable style="width: 20%" />
        </el-form-item>
        <!-- 备注 -->
        <el-form-item :label="$t('poReturn.createRemark')+ ':'">
          <el-input type="textarea" :rows="3" v-model="listQuery.remark" style="width: 30%" />
        </el-form-item>
      </el-form>
      <div style="text-align: center; margin-bottom: 10px">
        <el-button type="primary" :loading="saveLoading" @click="addSaveBtn">{{ $t('button.save') }}</el-button>
        <el-button icon="el-icon-close" @click="closeBtn">{{ $t('operation.button.cancel') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {addByDTO} from "@/api/fi/acFbexcash";
import {balanceSum} from "@/api/member";

export default {
  name: "BonusElectronicCurrencyAdd",
  data(){
    return{
      balance: '',
      saveLoading:false,
      listQuery:{},
      rules: {
        money: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: '[blur, change]'}],
        payPassword: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: '[blur, change]'}]
      }
    }
  },
  created() {
    this.getSum()
  },
  methods:{
    addSaveBtn() {
      this.saveLoading = true
      this.$refs['addRef'].validate((valid) => {
        if (valid) {
          addByDTO({...this.listQuery}).then(() => {
            this.$router.back()
            this.$message.success(this.$t('bdSendRegister.operaterSuccess'))
            this.saveLoading = false
            this.resetForm('addRef')
          }).catch(err => {
            console.error(err)
            this.saveLoading = false
            this.$message.error(this.$t('bdSendRegister.operaterFail'))
          })
        } else {
          this.saveLoading = false
        }
      })
    },
    closeBtn() {
      this.$router.back()
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    // 获取余额
    getSum() {
      balanceSum().then(res => {
        this.balance = res.data.canUseFb || 0
      })
    }
  }
}
</script>

<style scoped>

</style>
